import { Fragment } from 'react';
import { Col, Form, Row } from 'react-bootstrap';

import { ControlesLinha, ProcessoInput } from '../../components/RelatorioCivelComponents';

import type { RelatorioCivelStepProps } from './relatorio-civel-step-props';

export default function Step05Replica(props: RelatorioCivelStepProps) {
  const {
    novoProcessoReplica,
    setNovoProcessoReplica,
    adicionarProcesso,
    quantidadeLinhas,
    setQuantidadeLinhas,
    adicionarMultiplasLinhas,
    isViewMode,
    formData,
    renderTabelaProcessos,
  } = props;

  return (
    <Fragment>
      {!isViewMode && (
        <Row className="mb-4">
          <Col md={12}>
            <Form.Group>
              <Form.Label className="fw-bold">N.º do Processo</Form.Label>
              <ProcessoInput
                value={novoProcessoReplica}
                onChange={setNovoProcessoReplica}
                onAdicionar={() => adicionarProcesso('replica', novoProcessoReplica, setNovoProcessoReplica)}
              />
              <Form.Text className="text-muted">
                Pressione Enter ou clique em Adicionar para incluir o processo na lista
              </Form.Text>
            </Form.Group>
          </Col>
        </Row>
      )}

      {!isViewMode && (
        <ControlesLinha
          quantidade={quantidadeLinhas.replica}
          onDecrementar={() =>
            setQuantidadeLinhas((prev) => ({ ...prev, replica: Math.max(1, prev.replica - 1) }))
          }
          onIncrementar={() =>
            setQuantidadeLinhas((prev) => ({ ...prev, replica: Math.min(50, prev.replica + 1) }))
          }
          onQuantidadeChange={(value: number) => setQuantidadeLinhas((prev) => ({ ...prev, replica: value }))}
          onAdicionar={() => adicionarMultiplasLinhas('replica')}
          totalLabel="Total de Processos"
          totalCount={formData.replica.processos.length}
        />
      )}

      {renderTabelaProcessos('replica', formData.replica.processos)}
    </Fragment>
  );
}

